// Home.js
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { nomesService, arrendatarioService } from "./services/api";
import AtivarServicoCard from "./components/Home/AtivarServicoCard";
import StatusContaCard from "./components/Home/StatusContaCard";
import NomesCadastradosCard from "./components/Home/NomesCadastradosCard";
import CredenciaisModal from "./components/Home/CredenciaisModal";

const Home = () => {
  const [arrendatario, setArrendatario] = useState(null); // Guarda o objeto completo
  const [nomesConfig, setNomesConfig] = useState(null);
  const [loadingArrendatario, setLoadingArrendatario] = useState(true);
  const [loadingNomes, setLoadingNomes] = useState(true);
  const [criandoArrendatario, setCriandoArrendatario] = useState(false);
  const [showCredenciaisModal, setShowCredenciaisModal] = useState(false);
  const [credenciaisForm, setCredenciaisForm] = useState({ nome: "", login: "", senha: "" });
  const [savingCredenciais, setSavingCredenciais] = useState(false);
  const [showSenha, setShowSenha] = useState(false);
  const navigate = useNavigate();

  // Buscar arrendatário
  const fetchArrendatario = useCallback(async () => {
    setLoadingArrendatario(true);
    try {
      const resultado = await arrendatarioService.buscarArrendatario();
      setArrendatario(resultado || null);
    } catch (e) {
      setArrendatario(null);
    }
    setLoadingArrendatario(false);
  }, []);

  // Buscar nomes
  const fetchNomes = useCallback(async () => {
    setLoadingNomes(true);
    try {
      const resultado = await nomesService.buscarNomes();
      setNomesConfig(Array.isArray(resultado) && resultado.length > 0);
    } catch (e) {
      setNomesConfig(false);
    }
    setLoadingNomes(false);
  }, []);

  useEffect(() => {
    fetchArrendatario();
    fetchNomes();
  }, [fetchArrendatario, fetchNomes]);

  // Criar arrendatário
  const handleCriarArrendatario = async () => {
    setCriandoArrendatario(true);
    try {
      await arrendatarioService.criarArrendatario();
      await fetchArrendatario();
    } catch (e) {
      alert("Erro ao criar conta do arrendatário");
    }
    setCriandoArrendatario(false);
  };

  const openCredenciaisModal = () => {
    if (!arrendatario) return;
    setCredenciaisForm({
      nome: arrendatario.nome || "",
      login: arrendatario.login || "",
      senha: arrendatario.senha || "",
    });
    setShowSenha(false);
    setShowCredenciaisModal(true);
  };

  const closeCredenciaisModal = () => {
    if (savingCredenciais) return;
    setShowCredenciaisModal(false);
  };

  const handleCredenciaisChange = (e) => {
    const { name, value } = e.target;
    setCredenciaisForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSalvarCredenciais = async (e) => {
    e.preventDefault();
    if (!arrendatario) return;
    setSavingCredenciais(true);
    try {
      await arrendatarioService.atualizarArrendatario({
        nome: credenciaisForm.nome,
        login: credenciaisForm.login,
        senha: credenciaisForm.senha,
      });
      await fetchArrendatario();
      setShowCredenciaisModal(false);
    } catch (error) {
      alert("Erro ao atualizar as credenciais de acesso.");
    }
    setSavingCredenciais(false);
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">Configuração</h1>
        <p className="text-sm text-muted-foreground mt-1">Configure seu ambiente de distribuição</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <AtivarServicoCard
          arrendatario={arrendatario}
          loadingArrendatario={loadingArrendatario}
          criandoArrendatario={criandoArrendatario}
          onCriarArrendatario={handleCriarArrendatario}
        />

        {arrendatario && (
          <StatusContaCard
            arrendatario={arrendatario}
            onCorrigirCredenciais={openCredenciaisModal}
          />
        )}

        <NomesCadastradosCard
          nomesConfig={nomesConfig}
          loadingNomes={loadingNomes}
          onNavigateNomes={() => navigate("/nomes")}
        />
      </div>

      <CredenciaisModal
        isOpen={showCredenciaisModal}
        credenciaisForm={credenciaisForm}
        showSenha={showSenha}
        savingCredenciais={savingCredenciais}
        onClose={closeCredenciaisModal}
        onChange={handleCredenciaisChange}
        onSubmit={handleSalvarCredenciais}
        onToggleShowSenha={() => setShowSenha((prev) => !prev)}
      />
    </div>
  );
};

export default Home;
